﻿'use strict';

/**
 * @ngdoc function
 * @name ntmApp.controller:dataCollectionDialogCtrl
 * @description
 * # dataCollectionDialogCtrl
 * Controller of the ntmApp
 */
angular.module('ntmApp')
  .controller('dataCollectionDialogCtrl', function ($uibModalInstance, $scope, data) {
      $scope.data = data;

      $scope.dismiss = function () {
          $uibModalInstance.dismiss();
      };

      $scope.complete = function () {
          $uibModalInstance.close(data);
      };

      $scope.notAllRequiredAreFilled = function () {
          return data.dataCollectionItems.some(function (item) {
              return item.name && item.required && item.value === undefined;
          });
      };
  });